import React,{useState, useEffect} from 'react';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import { Form, Radio, Button, Modal } from 'antd';
import FormSteps from '../Form/Form';
import Immagine from '../../../components/Immagine/Immagine';
import { useSelector } from 'react-redux';


const PersonaEsposta = (props) => {

    const [visible,setVisible] = useState(false);
    
    const erroriSalvaStep = useSelector(state => state.dataReducer.salvaStep.dati);
    const [errorMessagePersonaEsposta, setErrorMessagePersonaEsposta] = useState(null);

    useEffect(() => {
        if(erroriSalvaStep){
            erroriSalvaStep.forEach(errore => {
                switch(errore.errorCode) {
                    case "personaEsposta":
                        setErrorMessagePersonaEsposta(errore.errorMessage);
                    break;
                    default:
                        setErrorMessagePersonaEsposta(null);
                    break;
                }
            });
        }else{
            setErrorMessagePersonaEsposta(null);
        }
    }, [erroriSalvaStep]);

  function showModal(){
    setVisible(!visible);
  }

    return (
        <div className={stylesForm.Form}>

            <HeaderStep titolo='PEP' sottotitolo ='Sei una persona politicamente esposta?' />

            <FormSteps formId="step4" bloccoAvanzamento={false}>

            <Form.Item name="personaEsposta" help={errorMessagePersonaEsposta}
            rules={[
                {
                    required: true,
                    message: 'Scegli il valore corretto',
                }
            ]}
            >
                <Radio.Group>
                    <Radio.Button value={true}>Si, lo sono</Radio.Button>
                    <Radio.Button value={false}>No, non lo sono</Radio.Button>
                </Radio.Group>
            </Form.Item>

            <Button type='info' className={stylesForm.ButtonInfo} onClick={showModal}>Chi è una persona politicamente esposta?</Button>

            <div className={stylesForm.Clear}></div>

                <Modal
                onCancel={showModal}
                open={visible}
                closeIcon={<Immagine urlImage={'close-modal.svg'}  name='close' />}
                >
                <h2>Chi è una persona politicamente esposta?</h2>
                <p>Coloro che ricoprono o hanno ricoperto un’importante carica pubblica o i loro congiunti o soci in affari vengono definiti "Persone Politicamente Esposte" o "PEP".</p>
                </Modal>

            </FormSteps>
        </div>
    )
}

export default PersonaEsposta;